import { I18n } from "@/i18n/I18n";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";
import { Dropdown } from "react-bootstrap";
import { forwardRef, LegacyRef, MouseEvent } from 'react';
import { BasicButton } from "../buttons/BasicButton";

export function CustomFieldDropdown(props: {
  onClick: (fieldType: CUSTOM_FIELD_TYPES) => void;
  label: string;
  includeFile?: boolean;
}) {
  const { onClick, label, includeFile } = props;

  return (
    <Dropdown id="dropdown" title="field input">
      <Dropdown.Toggle
        size="sm"
        as={FieldInputToggle({ label })}
      />
      <Dropdown.Menu >
        <Dropdown.Item
          onClick={() => onClick(CUSTOM_FIELD_TYPES.String)}
        >
          {I18n.get('string')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => onClick(CUSTOM_FIELD_TYPES.MultilineText)}
        >
          {I18n.get('multilineText')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => onClick(CUSTOM_FIELD_TYPES.Integer)}
        >
          {I18n.get('integer')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => onClick(CUSTOM_FIELD_TYPES.Float)}
        >
          {I18n.get('float')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => onClick(CUSTOM_FIELD_TYPES.Boolean)}
        >
          {I18n.get('boolean')}
        </Dropdown.Item>
        {includeFile && <Dropdown.Item
          onClick={() => onClick(CUSTOM_FIELD_TYPES.File)}
        >
          {I18n.get('file')}
        </Dropdown.Item>}
      </Dropdown.Menu>
    </Dropdown>
  );
}


type CustomToggleProps = {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

function FieldInputToggle(props: { label: string }) {
  const { label } = props;
  return (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    forwardRef(({ onClick }: CustomToggleProps,  ref: LegacyRef<HTMLButtonElement>) => (
      <BasicButton
        onClick={(event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
          event.preventDefault();
          onClick(event);
        }}
        label={label}
      />
  )));
}

